import { type AgentSubscriber, type Message } from "@ag-ui/client";
import { RemoteAgUiData } from "app/infrastructure/remote-data";
import { endpoint } from "app/components/ai-chat-assistant/constants";

type RunAgUiArgs = {
  tenant: string;
  context: string;
  threadId: string;
  messages: Message[];
  subscriber: AgentSubscriber;
  abortController?: AbortController;
};

export const api = {
  executeAiAssistantRun: async ({
    tenant,
    context,
    threadId,
    messages,
    subscriber,
    abortController
  }: RunAgUiArgs): Promise<void> => {
    const remote = new RemoteAgUiData(endpoint.agui);
    await remote.run({
      tenant,
      context,
      threadId,
      messages,
      subscriber,
      abortController
    });
  }
};
